import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Button, CardActions } from "@mui/material";

interface ClassCardProps {
  className: string;
  professorName: string;
  classID: string;
  onClick: () => void; // Function to handle class selection
}

const ClassCardForStudent: React.FC<ClassCardProps> = ({
  className,
  professorName,
  classID,
  onClick,
}) => {
  return (
    <Card
      component="div"
      sx={{ minWidth: 275, cursor: 'pointer' }}
      onClick={onClick}
    >
      <CardContent>
        <Typography variant="h5" component="div">
          {className}
        </Typography>
        <Typography variant="body2">Professor: {professorName}</Typography>
      </CardContent>
      <CardActions>
        <Button size="small">
          Select Class
        </Button>
      </CardActions>
    </Card>
  );
};

export default ClassCardForStudent;
